import reduceReducers from "reduce-reducers";
import { initialState as documentsSidebarMenuInitialState, reducer as documentsSidebarMenuReducer } from "../Documents";
import { initialState as settingsSidebarMenuInitialState, reducer as settingsSidebarMenuReducer } from "../Settings";
import { initialState as summaryReportSidebarMenuInitialState, reducer as summaryReportSidebarMenuReducer } from "../SummaryReports";
import { initialState as workSpacesSidebarMenuInitialState, reducer as workSpacesSidebarMenuReducer } from "../WorkSpaces";
import { initialState as switcherInitialState, reducer as switcherReducer } from "../switcher";
export const initialState = {
    ...switcherInitialState,
    ...workSpacesSidebarMenuInitialState,
    ...documentsSidebarMenuInitialState,
    ...summaryReportSidebarMenuInitialState,
    ...settingsSidebarMenuInitialState
};
export default reduceReducers(initialState, workSpacesSidebarMenuReducer, documentsSidebarMenuReducer, summaryReportSidebarMenuReducer, switcherReducer, settingsSidebarMenuReducer);
